
import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import { toast } from "react-toastify";
import LoandSideBar from "../../LoansSideBar"
import swal from "sweetalert";

import loanCss from '../../../../css/loanRegisterEir.module.css'

import Breadcrumb from "../../../../components/Breadcrumb"
import commoncss from "../../../../css/common.module.css"

import  { ReactComponent as PervBtnIcon }  from '../../../../assets/icons/pervECLBtnIcon.svg'
import  { ReactComponent as BreadCrumbsdor }  from '../../../../assets/icons/breadCrumbsDot.svg'
import  { ReactComponent as EditIcon }  from '../../../../assets/icons/editCard.svg'
import  { ReactComponent as CompleteECLIcon }  from '../../../../assets/icons/completeECL.svg'
import  { ReactComponent as RefershIcon }  from '../../../../assets/icons/loanRegisterRefersh.svg'
import  { ReactComponent as LoaderIcon }  from '../../../../assets/icons/loansLoader.svg'

import Table from "../../../../elements/Table"


import {getAllLoanEIRScenario, selectLoanEIRScenario, getLoanMapping, setLoanEIRFields, confirmPDData, confirmLGDData,
        confirmFLFData, calculateEIR, viewWorking, addToLoanListing, getLoansData } from '../../../../../Bookclosure/Services/ApiHandler'

import  { ReactComponent as NextBtnIcon }  from '../../../../assets/icons/rightWhite.svg'

const ReceivablesRegisterEir = () => {

    const { id, companyId } = useParams();
    const [loanID, setloanID] = useState(id)
    const [companyID, setcompanyID] = useState(companyId)
    // const [companyID, setcompanyID] = useState('6655b5365ce609ea146c5c53')
    // const [loanID, setloanID] = useState('676cf724e5e1156fbf63b571')
    
    // active stage
    const [ActiveStage, setActiveStage] = useState(1)
    
    const numberofStages = [1, 2, 3]

    // Stage One
    const [stageOneOptions , setStageOneOptions] = useState([])
    const [stageOneScenarioId , setstageOneScenarioId] = useState()

    // stage Two
    const [stageTwoOptions , setstageTwoOptions] = useState([])
    const [stageTwoStageOptionValue , setstageTwoStageOptionValue] = useState()
    const [outStandingLoanAmount , setoutStandingLoanAmount] = useState([])
    const [outStandingProvisionFeeAmount , setoutStandingProvisionFeeAmount] = useState([])
    const [loanTerm , setloanTerm] = useState([])

    // Stage Three
    const [StageThreePostition, setStageThreePostition] = useState(1)
    const [StageThreeData,setStageThreeData] = useState()
    const [stageThreeTableHeaders , setstThreeTableHeaders] = useState([])
    const [stageThreeTableBody , setstageThreeTableBody] = useState([])

    const addLoanToListing = () => {
        addToLoanListing(loanID,'EIR').then(() => {
            toast.success("Successfully Add to Loan listing.");
        })
    }

    useEffect(() => {
        // We fetch options **after** the user makes a selection.
        // The selected data is then mapped with the fetched options to auto-fill the input fields.
        // This logic must remain intact.

        // Stage One Options Api
        getAllLoanEIRScenario(companyID).then(Response => {
            let loansList = Response.data.loanEIRScenarioList;

            // Map loan list to dropdown format
            const formattedOptions = loansList.map(loanItem => ({
                value: loanItem._id,
                label: loanItem.name
            }));

            setStageOneOptions(formattedOptions);
            setstageOneScenarioId(formattedOptions?.[0]._id)
        });

        // stage two api
        getLoanMapping(loanID, setloanID).then(Response => {
            let loansList = Response.data.fields;

            const stageTwoformattedOptions = loansList?.map(loanItem => ({
                value: loanItem,
                label: loanItem
            }));

            setstageTwoOptions(stageTwoformattedOptions)

        })

        getLoansData(loanID).then(Response => {
            let loanDt = Response.data.loan

            if(loanDt?.loanEIRScenarioID){
                setstageOneScenarioId(loanDt?.loanEIRScenarioID)
            }

            if(loanDt?.loanEIRStageColumn){
                setstageTwoStageOptionValue(loanDt?.loanEIRStageColumn)
            }

            if(loanDt?.loanEIROutstandingColumns){
                setoutStandingLoanAmount(loanDt?.loanEIROutstandingColumns)
            }

            if(loanDt?.loanEIRProvisionFeesColumns){
                setoutStandingProvisionFeeAmount(loanDt?.loanEIRProvisionFeesColumns)
            }

            if(loanDt?.loanEIRTermColumn){
                setloanTerm(loanDt?.loanEIRTermColumn)
            }

        })

    },[])

    const getComputeEir = () => {
        setStageThreePostition(2); // show loading or computing state
        calculateEIR(loanID)
            .then((res) => {
                
                setstThreeTableHeaders(res.data.EIRHeaders);
                const body = res.data.EIRTable.map(row => Object.values(row));
                setstageThreeTableBody(body);
                setStageThreeData(res.data);
                setStageThreePostition(3); // move to final view
                
            })
            .catch((err) => {
                setStageThreePostition(1); // go back to initial or show error
        });
    };

    return (
        <div style={{ display: 'flex' }}>
            <LoandSideBar 
                id = {id}
                companyId={companyId}
                activeTab={'Compute Calculations'}
                subMenuItem={'EIR'} 
            />

            <div className={loanCss.mainContainer}>

                <EclHeader 
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                    companyID={companyID}
                    loanID={loanID}
                />
                
                {numberofStages.includes(ActiveStage) ? (
                        <StageNumberBadge 
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                        />
                ) : ''}
                    
                <div className={ numberofStages.includes(ActiveStage) ? loanCss.subContainer : loanCss.subCatgeoryContainer}>

                    
                    <div className={
                                    numberofStages.includes(ActiveStage)
                                    ? loanCss.stagesContantHoldContainer
                                    : loanCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                    }>

                        {
                            ActiveStage === 1 
                                ? 
                                    <StageOne 
                                        stageOneOptions={stageOneOptions}
                                        stageOneScenarioId={stageOneScenarioId}
                                        setstageOneScenarioId={setstageOneScenarioId}
                                    /> 
                                :
                            
                            ActiveStage === 2 
                                ? 
                                    <StageTwo
                                        loanID={loanID}
                                        stageTwoOptions={stageTwoOptions}
                                        stageTwoStageOptionValue={stageTwoStageOptionValue} 
                                        setstageTwoStageOptionValue={setstageTwoStageOptionValue}
                                        outStandingLoanAmount={outStandingLoanAmount}
                                        setoutStandingLoanAmount={setoutStandingLoanAmount}
                                        outStandingProvisionFeeAmount={outStandingProvisionFeeAmount} 
                                        setoutStandingProvisionFeeAmount={setoutStandingProvisionFeeAmount}
                                        loanTerm={loanTerm} 
                                        setloanTerm={setloanTerm}
                                    /> 
                                :

                            ActiveStage === 3 
                                ? 
                                    <StageThree 
                                        // computeEir={computeEir}
                                        getComputeEir={getComputeEir}
                                        StageThreePostition={StageThreePostition}
                                        setStageThreePostition={setStageThreePostition}
                                        addLoanToListing={addLoanToListing}
                                        stageThreeTableHeaders={stageThreeTableHeaders}
                                        stageThreeTableBody={stageThreeTableBody}
                                    /> 
                                :
                            
                            null
                        }

                    </div>

                </div>

                {numberofStages.includes(ActiveStage) ? (
                        <EclFooter 
                            loanID={loanID}
                            stageOneScenarioId={stageOneScenarioId}
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}

                            stageTwoStageOptionValue={stageTwoStageOptionValue}
                            outStandingLoanAmount={outStandingLoanAmount}
                            outStandingProvisionFeeAmount={outStandingProvisionFeeAmount}
                            loanTerm={loanTerm}
                        />
                ) : ''}
           
            </div>


        </div>
    );
};

export default ReceivablesRegisterEir;



const StageNumberBadge = ({
    ActiveStage,
    setActiveStage,
    }) => {

        var outerBadge1 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter1 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
        var content1 = 1

        var outerBadge2 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
        var content2 = 2

        var outerBadge3 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`
        var innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
        var badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.inactiveBadgeBgClr}`
        var content3 = 3

        if (ActiveStage === 1) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.activeBadgeBgClr}`
                content1 = 1
            } 
            else if (ActiveStage === 2) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.completedBadgConnecterClr}`
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`
                innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.middleActiveBar} `

                badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.lastInActiverBar} `
            } 
            else if (ActiveStage === 3) {
                outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
                innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr} `
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`
                innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
                badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr} `
                content2 = <CompleteECLIcon />

                outerBadge3 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`
                innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
                badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.lastConnecter} `
            } 

    return (

        <div className={loanCss.numBadgeMainContainer}>
            <div className={loanCss.numberContainer}>
                <div onClick={ () => {} } key={1} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerOne}`}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${loanCss.badge}`} >
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText1}`}>Scenario</div>
                </div>
                <div onClick={ () => {} } key={2} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${loanCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText2}`}>edit fields</div>
                </div>
                <div onClick={ () => {} } key={3} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${loanCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText3}`}>compute eir</div>
                </div>
            </div>
        </div>
    );
};


const StageOne = ({
    stageOneOptions,
    stageOneScenarioId,
    setstageOneScenarioId
    }) => {

    return(
        <div className={loanCss.stage1MainContainer}>
            <div className={loanCss.stage1SubContainer}>
                <div>
                    <div className={loanCss.scenarioLabelClr}>Scenario</div>
                    <div className={loanCss.editPolicyContainer}>
                        <Select
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            defaultValue={stageOneOptions?.[0]}
                            value={stageOneScenarioId ? stageOneOptions.find(option => option.value === stageOneScenarioId) : stageOneOptions?.[0]}
                            onChange={(selectedOption) => setstageOneScenarioId(selectedOption.value)}
                            options={stageOneOptions}
                            placeholder="Select Scenario"
                            name="status"
                            className={`mt-0 ${loanCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                        <div className={loanCss.stageOneEditScenarioContainer}>
                            <span>
                                <EditIcon className={loanCss.scenarioEditIcon} />
                            </span>
                            <span className={loanCss.customGreenText}>
                                Edit in Policies
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    
}


const StageTwo = ({
    loanID,
    stageTwoOptions,
    stageTwoStageOptionValue,
    setstageTwoStageOptionValue,
    outStandingLoanAmount,
    setoutStandingLoanAmount,
    outStandingProvisionFeeAmount, 
    setoutStandingProvisionFeeAmount,
    loanTerm, 
    setloanTerm,
    }) => {

    return(
        <div className={loanCss.stageTwoMainContainer}>
            
            <div className={loanCss.stageTwoSubContainer}>
                
                <div className={loanCss.stageTwoStageSelectContainer}>
                    <div className={loanCss.scenarioLabelClr}>Stage</div>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        onChange={(selectedOption) => setstageTwoStageOptionValue(selectedOption.value)}
                        value={stageTwoOptions?.find(opt => opt.value === stageTwoStageOptionValue) || stageTwoOptions?.[0]}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"    
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>

                <div className={loanCss.stageTwoStageSelectContainer}>
                    <div className={loanCss.scenarioLabelClr}>Outstanding Provision Fees Amount</div>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        // onChange={(selectedOption) => setoutStandingProvisionFeeAmount(selectedOption.value)}
                        onChange={(selectedOption) => {
                            setoutStandingProvisionFeeAmount(prev => {
                                const newValue = selectedOption.value;
                                return prev.includes(newValue) ? prev : [...prev, newValue];
                            });
                        }}
                        value={stageTwoOptions?.find(opt => opt.value === outStandingProvisionFeeAmount?.[outStandingProvisionFeeAmount?.length - 1]) || stageTwoOptions?.[0]}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"    
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>

            </div>

            <div className={loanCss.stageTwoSubContainer}>
                
                <div className={loanCss.stageTwoStageSelectContainer}>
                    <div className={loanCss.scenarioLabelClr}>Outstanding Loan Amount</div>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        // onChange={(selectedOption) => setoutStandingLoanAmount(selectedOption.value)}
                        onChange={(selectedOption) => {
                            setoutStandingLoanAmount(prev => {
                                const newValue = selectedOption.value;
                                return prev.includes(newValue) ? prev : [...prev, newValue];
                            });
                        }}
                        // value={stageTwoOptions?.find(opt => opt.value === outStandingLoanAmount) || stageTwoOptions?.[0]}
                        value={stageTwoOptions?.find(opt => opt.value === outStandingLoanAmount?.[outStandingLoanAmount?.length - 1]) || stageTwoOptions?.[0]}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>
                
                <div className={loanCss.stageTwoStageSelectContainer}>
                    <div className={loanCss.scenarioLabelClr}>Loan Term</div>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        onChange={(selectedOption) => setloanTerm(selectedOption.value)}
                        value={stageTwoOptions?.find(opt => opt.value === loanTerm) || stageTwoOptions?.[0]}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>

            </div>

        </div>
    )
    
}


const StageThree = ({
    loanID,
    ActiveStage,
    setActiveStage,
    addLoanToListing,
    StageThreePostition,
    setStageThreePostition,
    getComputeEir,
    stageThreeTableHeaders,
    stageThreeTableBody
    }) => {

    const StageSixStartCompute = () =>{
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainer}>
                    <div className={loanCss.DedupecomputText}>Lorem ipsum dolor sit amet consectetur.Scelerisque</div>
                    <div className={loanCss.DedupecomputText}>luctus morbi odio orci. Tellus risus et id.</div>
                    <div> 
                        <button type="button" 
                            style={{ marginTop:'10px' }} className={`${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                            onClick={() => {getComputeEir()}}
                        >Compute EIR</button> </div>
                </div>
            </div>
        )
    }

    const StageSixLoader = () => {
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainerLoader}>
                    <LoaderIcon className={loanCss.spininfinite} />
                    <div className={loanCss.computText}>Computation in progress</div>
                    <div className={loanCss.computText}>This might take a few minutes, Please wait...</div>
                </div>
            </div>
        )
    }

    const StageSixDataView = ({}) => {
        return(
        <div className={`${loanCss.stageSixMainContainer} ${loanCss.tableEir}`}>
                <div className={loanCss.stageSixbtnContainer}>
                    <div className={loanCss.stageSixbtnLeftContainer}>
                        <button style={{ marginRight : '10px' }} type="button" className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`}> <RefershIcon /> Refresh</button>
                        <button className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`} type="button">Start Over</button>
                    </div>
                    <div className={loanCss.stageSixbtnRightContainer}>
                        {/* <button type="button"
                            className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`}
                            onClick={() => { setActiveStage('view') }}
                        >View Workings</button> */}
                        <button 
                            style={{ marginLeft : '10px' }} 
                            type="button" 
                            className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                            onClick={() => addLoanToListing()}
                            >Add columns to loan listing</button>
                    </div>
                </div>
                <div className={loanCss.stageThreeScrollWrapper}>
                    <div className={loanCss.stageThreeTable}>
                    <div className={loanCss.stageThreeTableHeader}>
                        {stageThreeTableHeaders.map((header, index) => (
                            <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                {header}
                            </div>
                        ))}
                    </div>

                    <div className={loanCss.stageSixTableBody}>
                        {stageThreeTableBody.map((row, rowIndex) => (
                            <React.Fragment >
                                <div className={loanCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                    {row.map((cell, cellIndex) => (
                                        <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                            {cell}
                                        </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                    </div>
                </div>
            </div>
        )
    }
    
    return(
        <React.Fragment>
            {StageThreePostition === 1 && <StageSixStartCompute />}
            {StageThreePostition === 2 && <StageSixLoader />}
            {StageThreePostition === 3 && <StageSixDataView />}
        </React.Fragment>
    )
    
}


const EclHeader = ({
    ActiveStage,
    setActiveStage,
    companyID,
    loanID,
    }) => {

        const breadcrumbItems = [
            {
                label: "Loan Register",
                link: `/myfinV2/overview/${loanID}/${companyID}`,
                className: `${commoncss.nav_cnt_color} clickable`,
            },
            {
                label: "Compute Calculations",
                className: `${commoncss.nav_cnt_color} clickable`,
            },
            {
                label: "EIR",
                className: `${commoncss.nav_cnt_color} clickable`,
            },
        ];

    return(
        // <div className={loanCss.headerContainer}>
        //     <div className={loanCss.eclbreadCumbs} 
        //         onClick={() => {
        //             if (ActiveStage === 'view') {
        //                 setActiveStage(6);
        //             }
        //         }}
        //         >
        //         <PervBtnIcon />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         Loans
        //     </div>
        //     <div className={loanCss.breadCumbContainer}>
        //         <BreadCrumbsdor />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         EIR
        //     </div>
        // </div>
        <Breadcrumb
            addCls="bgTransprent"
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
        />
    )
}


const EclFooter = ({ 
    loanID,
    stageOneScenarioId,
    ActiveStage,
    setActiveStage,
    stageTwoStageOptionValue,
    outStandingLoanAmount,
    outStandingProvisionFeeAmount,
    loanTerm,
    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    return(
        <div className={loanCss.footerContainer}>
            <div>
                <button 
                onClick={() => {handleClick('/myfinv2/company-edit/accounting-policy/10')}}
                className={loanCss.cancelBtn} type="button">Cancel</button>
            </div>
            <div className={loanCss.footerbtnContainer}>
                <button 
                    onClick={() => {
                        if (ActiveStage !== 1) {
                            setActiveStage(ActiveStage - 1);
                        }
                    }}
                    className={loanCss.perviewBtn} type="button"> 
                    <PervBtnIcon /> Previous
                </button>
                <button
                    onClick={()=>{ 
                        if(ActiveStage !== 3){
                            if(ActiveStage === 1){
                                selectLoanEIRScenario(loanID,stageOneScenarioId)
                            }
                            if(ActiveStage === 2){
                                let obj = {
                                            "loanEIRStageColumn": stageTwoStageOptionValue,
                                            "loanEIROutstandingColumns": outStandingLoanAmount,
                                            "loanEIRProvisionFeesColumns": outStandingProvisionFeeAmount,
                                            "loanEIRTermColumn": loanTerm
                                            }
                                            
                                setLoanEIRFields(loanID,obj).then(() => {
                                })
                            }
                            setActiveStage(ActiveStage + 1) 
                        }

                    }} 
                    className={loanCss.saveBtn} type="button">
                    { ActiveStage === 3 ? 'Finish' : 'Next'}<NextBtnIcon/>
                </button>
            </div>
        </div>
    )
}


export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
